module.exports = __webpack_public_path__ + "img/KLN_login_people.8e8e5e95.png";